module.exports = __webpack_public_path__ + "static/beholder-8606f6998eac2ff3ad38edb2ac640555.jpg";